import { failedNotification, successfulNotification } from "common/utils/notifications";
import {
  buildUserPayloadFromForm,
  getDirectDashboardsToPersist,
} from "./userEditUtils";

interface SaveUserEditsOptions {
  umsClient: { patch: (url: string, payload: Record<string, any>) => Promise<unknown> };
  socket?: { emit: (event: string) => void };
  userId: string;
  values: Record<string, any>;
  rolesList?: any[];
  originalUser: any;
  canManagePrivileges: boolean;
  onSaved?: () => void | Promise<void>;
}

export const saveUserEdits = async ({
  umsClient,
  socket,
  userId,
  values,
  rolesList = [],
  originalUser,
  canManagePrivileges,
  onSaved,
}: SaveUserEditsOptions): Promise<boolean> => {
  try {
    // UMS independently requires Mercury.Users.edit and an authenticated admin
    // for admin, vendorManager, or userLevelPermissions updates before persistence.
    const payload = buildUserPayloadFromForm(values, { canManagePrivileges, originalUser });
    payload.dashboards = getDirectDashboardsToPersist(
      values.dashboardsValue || [],
      values.rolesValue || [],
      rolesList,
      originalUser?.__originalUserDashboards || []
    );

    await umsClient.patch(`/ums-v1/users/${encodeURIComponent(userId)}`, payload);
    socket?.emit("updateUserDetails");
    await onSaved?.();
    successfulNotification("User updated", "User has been updated successfully.");
    return true;
  } catch (error: any) {
    failedNotification(
      "Error updating user",
      error?.response?.data?.message || error?.toString?.() || "Unknown error"
    );
    return false;
  }
};